import React, { useEffect } from "react";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { hideNotification } from "../../../store/features/ui/uiActions";

export function NotificationContainer() {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((state) => state.ui.notifications);

  useEffect(() => {
    notifications.forEach((notification) => {
      if (notification.duration !== 0) {
        const timer = setTimeout(() => {
          dispatch(hideNotification(notification.id));
        }, notification.duration || 5000);

        return () => clearTimeout(timer);
      }
    });
  }, [notifications, dispatch]);

  const getNotificationIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircle size={20} />;
      case "error":
        return <XCircle size={20} />;
      case "warning":
        return <AlertTriangle size={20} />;
      case "info":
        return <Info size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  const getNotificationClass = (type) => {
    switch (type) {
      case "success":
        return "alert-success";
      case "error":
        return "alert-danger";
      case "warning":
        return "alert-warning";
      case "info":
        return "alert-info";
      default:
        return "alert-info";
    }
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div
      className="notification-container position-fixed top-0 end-0 p-3"
      style={{ zIndex: 1050 }}
    >
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`alert ${getNotificationClass(
            notification.type
          )} alert-dismissible fade show mb-2`}
          role="alert"
          style={{ minWidth: "300px" }}
        >
          <div className="d-flex align-items-center">
            <div className="me-2">{getNotificationIcon(notification.type)}</div>
            <div className="flex-grow-1">{notification.message}</div>
            <button
              type="button"
              className="btn-close"
              onClick={() => dispatch(hideNotification(notification.id))}
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
}
